import React from "react";
import MiniCartItem from "theme/modules/Cart/CartItem/MiniCartItem";
import Link from "theme/components/atoms/Typography/Link";
import { defineMessages, useIntl } from "react-intl";
import Stack from "theme/components/atoms/Layout/Stack";

const messages = defineMessages({
  miniCartEmpty: {
    id: "modules.Cart.MiniCart.MiniCartContent.empty",
    defaultMessage: "You don't have any product in your cart yet.",
  },
  viewMore: {
    id: "modules.Cart.MiniCart.MiniCartContent.viewMore",
    defaultMessage: "See my {qty} products",
  },
});

const MiniCartItemList = ({ cart }) => {
  const intl = useIntl();
  return (
    <>
      {cart.items.length > 0 ? (
        <div className="mini-cart-item-list__items">
          <Stack desktopSize="1" mobileSize="4">
            {cart.items.slice(0, 4).map((item) => (
              <MiniCartItem key={item.item_id} item={item} cart={cart} />
            ))}
          </Stack>
          {cart.items.length > 4 && (
            <div key="viewAll" className="mini-cart-item-list__view-more">
              <Link to="/cart" buttonAppearance="default">
                {intl.formatMessage(messages.viewMore, {
                  qty: cart.items_qty,
                })}
              </Link>
            </div>
          )}
        </div>
      ) : (
        <div className="mini-cart-item-list__empty">
          {intl.formatMessage(messages.miniCartEmpty)}
        </div>
      )}
    </>
  );
};

export default MiniCartItemList;
